// Enums do QtsSemanal (espelham o backend - ajuste os 'value' caso a numeração seja diferente).

// StatusQtsSemanal: ciclo de vida da geração.
export const STATUS_QTS_SEMANAL = [
    { value: 1, label: 'RASCUNHO' },
    { value: 2, label: 'GERADO' },
    { value: 3, label: 'VALIDADO' },
    { value: 4, label: 'PUBLICADO' },
    { value: 5, label: 'CANCELADO' },
];

export function labelStatusQts(value: any): string {
    const v = value && typeof value === 'object' ? (value.id ?? value.value) : value;
    const found = STATUS_QTS_SEMANAL.find(s => s.value === Number(v));
    return found ? found.label : (value?.nome ?? String(value ?? ''));
}

// Normaliza o status (objeto Enumeration ou número) para o id numérico.
export function statusQtsId(value: any): number {
    const v = value && typeof value === 'object' ? (value.id ?? value.value) : value;
    return Number(v);
}

// Transições do ciclo de vida (espelham QtsSemanalPublicacaoService no backend).
// RASCUNHO(1) → GERADO(2) → VALIDADO(3) → PUBLICADO(4) | CANCELADO(5)
export function podeGerar(status: any): boolean {
    const s = statusQtsId(status);
    return s === 1 || s === 2; // RASCUNHO ou GERADO (regeração)
}
export function podeValidar(status: any): boolean {
    return statusQtsId(status) === 2; // GERADO
}
export function podePublicar(status: any): boolean {
    return statusQtsId(status) === 3; // VALIDADO
}
export function podeCancelar(status: any): boolean {
    return statusQtsId(status) !== 4; // qualquer status, exceto PUBLICADO
}
export function editavel(status: any): boolean {
    const s = statusQtsId(status);
    return s === 1 || s === 2; // só edita configuração enquanto RASCUNHO/GERADO
}

// TipoRestricao (RN11): tipos de restrição por disciplina do QTS.
// Cada tipo usa um subconjunto dos parâmetros (faixa de horário, dia, instrutor, espaço).
export const TIPOS_RESTRICAO = [
    { value: 1, label: 'Horário permitido', campos: ['horario'] },
    { value: 2, label: 'Horário proibido', campos: ['horario'] },
    { value: 3, label: 'Dia permitido', campos: ['dia'] },
    { value: 4, label: 'Dia proibido', campos: ['dia'] },
    { value: 5, label: 'Primeiro horário do dia', campos: [] },
    { value: 6, label: 'Último horário do dia', campos: [] },
    { value: 7, label: 'Instrutor fixo', campos: ['instrutor'] },
    { value: 8, label: 'Espaço fixo', campos: ['espaco'] },
    { value: 9, label: 'Não atribuir auxiliar (geração)', campos: [] },
    { value: 10, label: 'Não alocar espaço (sala do pelotão)', campos: [] },
    { value: 11, label: 'Permitir 4 aulas seguidas', campos: [] },
    { value: 12, label: 'Obrigar 4 aulas seguidas', campos: [] },
];

export function labelTipoRestricao(value: any): string {
    const v = value && typeof value === 'object' ? (value.id ?? value.value) : value;
    const found = TIPOS_RESTRICAO.find(t => t.value === Number(v));
    return found ? found.label : (value?.nome ?? String(value ?? ''));
}

export function camposRestricao(value: any): string[] {
    const v = value && typeof value === 'object' ? (value.id ?? value.value) : value;
    const found = TIPOS_RESTRICAO.find(t => t.value === Number(v));
    return found ? found.campos : [];
}
